<div class="mb-promo">
    <HeaderComponent
            :path-image-bck="'2026'"
            :visual="true"
    />
    <main>
        <section>
            <div class="wide-content-wrapper-cnt">
                <div v-if="contestActive">
                    <DataRangeComponent/>
                    <div class="home-subtitle">
                        <p class="tac" v-html="t('landing.textContest')"></p>
                    </div>
                    <h2 v-html="t('landing.title')"></h2>
                    <div class="home-description">
                        <span class="tac" v-html="t('landing.textInstructionContest')"></span>
                    </div>
                    <div class="home-terms-condition">
                        <span class="tac" v-html="t('landing.termsAndConditions')"></span>
                    </div>
                </div>
                <div class="chart-wrapper-intro" v-else>
                    <h2 v-html="t('landing.contestFinished')"></h2>
                    <p class="tac" v-html="t('landing.contestFinishedInfo')"></p>
                </div>

                <div class="image-box-container">

                    <ImageBoxComponent
                            v-for="image in paginatedImages"
                            :pid="image.pid"
                            :image-path="image.imgPath"
                            :selected="image.selected"
                            :user-logged="userLogged"
                            :contest-active="contestActive"
                    ></ImageBoxComponent>

                    <div class="load-more-container" v-if="numberTotal">
                        <ButtonComponent type="secondary"
                                         :text="t('landing.showMoreButton')"
                                         @click="loadMore"></ButtonComponent>
                    </div>

                    <ModalComponent></ModalComponent>
                </div>
                <div v-if="contestActive">
                    <div class="chart-wrapper-intro">
                        <h2 v-html="t('landing.title.2025.chart')"></h2>
                        <p v-html="t('landing.text.2025.chart')"></p>
                    </div>
                    <div class="chart-wrapper">
                        <ImageBoxComponent
                                v-for="image in chartPreviousYear"
                                :key="image.id"
                                :image-path="image.imgPath"
                                :selected="image.selected"
                                :ranking="image.ranking"
                                type="chart"
                        ></ImageBoxComponent>

                        <ModalComponent></ModalComponent>
                    </div>
                </div>
                <div class="general-rules tac">
                    <div v-html="t('general.rules')"></div>
                </div>
            </div>
        </section>
    </main>
    <FooterComponent type="homepage"></FooterComponent>
</div>